import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useGroups } from "../../../../features/Settings/General/OrganisationLevelGroups/context";
import { useOrgSettingsResourceLabel } from "../../../../utils/hooks/useOrgSettingsResourceLabel";
import {
    getSettingsOrgResourceSearchFilters,
    getSettingsResourceSearchFilters,
} from "../../../../utils/helpers/settings";

export const useDefaultConfig = () => {
    const { t } = useTranslation();
    const { allocatedGroups } = useGroups();
    const renderOrgLevelResourceLabel = useOrgSettingsResourceLabel();

    return useMemo(() => {
        const config = [
            {
                label: t("all-locations"),
                key: "location",
                url: "/locations",
                getSearchFilters: getSettingsResourceSearchFilters
            },
            {
                label: t("all-jobs"),
                key: "job",
                url: "/jobs",
                getSearchFilters: getSettingsResourceSearchFilters
            }
        ];

        if (allocatedGroups?.length > 0) {
            const allocatedGroupsConfig = allocatedGroups.map((group: any) => ({
                label: group.description,
                key: `${group.level.replaceAll("_", "")}`,
                url: `/${group.id}/org-levels`,
                getSearchFilters: getSettingsOrgResourceSearchFilters,
                renderItem: renderOrgLevelResourceLabel
            }));
            config.push(...allocatedGroupsConfig);
        }

        return config;
    }, [allocatedGroups, renderOrgLevelResourceLabel, t]);
}